import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { DOWNLOAD_CONTRACT_SUMMARY_TEST_ID, DOWNLOADABLE_FILE_NAME } from '../constants';
import { SmallerLink } from './TriggerDownloadLink.styles';

type Props = { text?: string; href: string; className: string; isNegative: boolean };

export const TriggerDownloadLink: FC<Props> = ({ href, className, text: textInit, isNegative }) => {
    const { t } = useTranslations();
    const text = textInit || t['plans.detailed_offer_download'];

    return (
        <SmallerLink
            href={href}
            target="_blank"
            rel="noreferrer"
            download={DOWNLOADABLE_FILE_NAME}
            variant="text"
            disableVisited={true}
            negative={isNegative}
            className={className}
            data-test={DOWNLOAD_CONTRACT_SUMMARY_TEST_ID.DOWNLOAD_LINK}
        >
            {text}
        </SmallerLink>
    );
};
